import { Action } from 'redux-actions';
import { SET_LOADING_OFF, SET_LOADING_ON } from './actions';

export default (state: boolean, action: Action<void>) => {
	switch (action.type) {
		case SET_LOADING_ON:
			return true;
		case SET_LOADING_OFF:
			return true;
		default:
			return false;
	}
};
